module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c11"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('strong', [_vm._v("c. 500 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("Change Is Constant")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Heraclitus")]), _vm._v(" (fl. c. 500 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Heraclitus is the most quotable of the pre-Socratic philosophers. From the 130 or so fragments of his writings that have survived, a vivid personality shines through: proud, passionate, contemptuous of the common herd, yet moved by a deep religious impulse to find unity in difference and order in apparent disorder. Like the Chinese sage Laozi, Heraclitus wrote in pithy, enigmatic aphorisms. For this reason, he was known in antiquity as Heraclitus the Obscure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heraclitus taught that all things are in flux. “Change alone is unchanging,” he declared. Though some things appear to be permanent and unchanging, a closer look reveals that “nothing stands but for [time’s] scythe to mow.” “You cannot step twice into the same river; for fresh waters are ever flowing in upon you.” “The sun is new every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another way in which Heraclitus reminds one of Laozi is in his doctrine of the “unity of opposites.” Both in nature and in human affairs, harmonies flow from the strife and tension of opposites. In the interplay of light and darkness, summer and winter, male and female lie the creative tensions that give meaning and richness to existence. “From things that differ comes the fairest attunement.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heraclitus offered his own take on the much-debated issue of whether there is some fundamental “stuff” out of which everything is made. His answer was fire. In ever-living fire, constantly renewing itself and transmuting all things into itself, he saw the essential pattern of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The deepest source of life’s goodness and harmony, Heraclitus believed, lies in what he called the “Logos” (the Greek word "), _c('em', [_vm._v("logos")]), _vm._v(" means “word” or “reason”), the divine word or universal reason. The Logos was not a personal god, but a fiery divine force or process ordering all things for the best through creative strife. “To God all things are beautiful and good and just; but men suppose some things to be just and others unjust.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heraclitus’s doctrine of the Logos, or universal reason, was picked up by the Stoics and contributed significantly to their teaching. It also was taken up, and given a fundamentally new interpretation, in the famous opening words of the Gospel of John: “In the beginning was the Word ["), _c('em', [_vm._v("Logos")]), _vm._v("], and the Word was with God, and the Word was God.”")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img33"
    }
  }, [_c('em', [_vm._v("Heraclitus, known as the Obscure or the Weeping Philosopher, in a painting by Dutch artist Hendrick ter Brugghen from 1628.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/33-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c03"
    }
  }, [_vm._v("The Dao (c. 550 BCE)")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c13"
    }
  }, [_vm._v("Change Is Illusory (c. 470 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epictetian Stoicism (c. 125)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d87d496","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c11.vue
// module id = 105
// module chunks = 0